<!--
 * @Description: 
 * @Date: 2020-07-27 11:25:02
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  methods: {
    ...mapMutations('living', ['SET_DEVICE']),
    //判断设备的型号去存到vueX里方便以后去做多端的适配
    handleMatchMedia() {
      const matchMedia = window.matchMedia;
      if (matchMedia('(max-width: 600px)').matches) {
        this.SET_DEVICE('Mobile'); //手机
      } else {
        this.SET_DEVICE('Desktop'); //电脑
      }
    }
  },
  mounted() {
    localStorage.setItem('windowUrl', window.location.href);
    this.handleMatchMedia();
  }
};
</script>
<style lang="less">
@import '~@/style/global.less';
#app {
  // width: 10rem;
  margin: 0 auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 全局的文本处理溢出的方式 */
  .text-overflow-1 {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .text-overflow-2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
  }
  .text-overflow-3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
  }
}
.missBox {
  text-align: center;
  padding: 0.64rem 0;
  img {
    width: 2rem;
    height: 2rem;
    margin-bottom: 0.68rem;
  }
  p {
    font-size: 0.43rem;
    font-weight: 400;
    color: rgba(149, 149, 153, 1);
    line-height: 0.43rem;
  }
}
// v-html 渲染内容
.vhtml {
  max-width: 100%;
  overflow-x: hidden;
}
.abs-mid {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.img-pc-dialog {
  padding-bottom: 0 !important;
  border: none !important;
  background-color: transparent !important;
  .el-message-box__header{
    padding: 0;
  }
  .el-message-box__title,
  .el-message-box__btns {
    display: none !important;
  }
  .el-message-box__content {
    padding: 0;
    margin-top: 0 !important;
    padding-right: 0 !important;
    padding-top: 0 !important;
    padding-left: 0 !important;
  }
  .el-message-box__headerbtn {
    z-index: 11;
    .el-message-box__close {
      color: rgba(255, 255, 255, 0.8) !important;
    }
  }
}
</style>
